import { render } from "./SearchAlgoliaMobile.vue?vue&type=template&id=97dae87c&scoped=true"
import script from "./SearchAlgoliaMobile.vue?vue&type=script&lang=js"
export * from "./SearchAlgoliaMobile.vue?vue&type=script&lang=js"

import "./SearchAlgoliaMobile.vue?vue&type=style&index=0&id=97dae87c&lang=css&scoped=true"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97dae87c"]])

export default __exports__